import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn} from '@angular/router';
import {ModeService} from '../services/mode.service';
import {map} from 'rxjs/operators';
import {Mode} from '../models/mode.model';


const modeUrlIsValid = (route: ActivatedRouteSnapshot, modes: Mode[]) => {
  return modes.some((mode: Mode) => {
    return route.url.some((url) => {
      return url.path == mode.urlName;
    });
  });
};

export const modeGuard = (route: ActivatedRouteSnapshot): CanActivateFn => {
  const modeService = inject(ModeService);
  return () => {
    if (!modeService.getModes()) {
      return modeService.fetchAllModes()
        .pipe(map((modes) => modeUrlIsValid(route, modes)));
    }

    return modeUrlIsValid(route, modeService.getModes());
  };
};
